import { auth } from "../../../firebase";

const isLocalEnv =
  process.env.REACT_APP_APP_ENV === "local" ||
  process.env.APP_ENV === "local" ||
  process.env.REACT_APP_ENABLE_E2E_HARNESS === "true";

const X_API_KEY =
  process.env.REACT_APP_X_API_KEY ||
  (isLocalEnv ? "0f247291-b4bb-4895-91ac-ba26af7e55a2" : "");

const TENANT_API_BASE = isLocalEnv
  ? "http://127.0.0.1:5001/twodata-dev/europe-west3/tenantapi"
  : "https://europe-west3-twodata-dev.cloudfunctions.net/tenantapi";

export async function fetchImageDataUrl(url: string): Promise<string | null> {
  try {
    const user = auth.currentUser;
    if (!user) return null;
    const token = await user.getIdToken();
    if (!token) return null;

    const resp = await fetch(
      `${TENANT_API_BASE}/download/image?` +
        new URLSearchParams({ downloadUrl: url }),
      {
        method: "GET",
        headers: {
          "x-api-key": X_API_KEY,
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!resp.ok) return null;
    const blob = await resp.blob();
    return await new Promise<string | null>((resolve, reject) => {
      const reader = new window.FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

export const updateTemplate = async (
  templateName: string,
  templateId: string,
  companyId: string,
  data: any
): Promise<any> => {
  const user = auth.currentUser;
  if (!user) return;
  const token = await user.getIdToken();

  return await fetch(
    `${TENANT_API_BASE}/altercapture/${templateId}?` +
      new URLSearchParams({ templateName, companyId }),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": X_API_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...data, companyId }),
    }
  )
    .then((resp) => {
      if (resp.ok) return resp.json();
    })
    .catch((error) => console.error(error));
};

export const deleteTemplate = async (templateName: string, templateId: string, companyId: string): Promise<any> => {
  const user = auth.currentUser;
  if (!user) return;
  const token = await user.getIdToken();

  return await fetch(
    `${TENANT_API_BASE}/deletecapture/${templateId}?` +
      new URLSearchParams({ templateName, companyId }),
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": X_API_KEY,
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((resp) => {
      if (resp.ok) return { code: 200 };
    })
    .catch((error) => console.error(error));
};

export const alterTemplateSubmission = async (
  submissionId: string,
  updatedData: any,
  companyId: string,
  submissionDate?: string | Date | any | null
): Promise<any> => {
  const user = auth.currentUser;
  if (!user) return;
  const token = await user.getIdToken();

  const body: Record<string, any> = { companyId };
  if (updatedData) {
    body.alterations = updatedData;
  }
  if (submissionDate) {
    body.submissionDate =
      typeof submissionDate?.toDate === "function"
        ? submissionDate.toDate().toISOString()
        : submissionDate instanceof Date
        ? submissionDate.toISOString()
        : submissionDate;
  }

  return await fetch(
    `${TENANT_API_BASE}/alterFlexFormTemplateSubmission/${submissionId}?` +
      new URLSearchParams({ companyId }),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": X_API_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    }
  )
    .then((resp) => {
      if (resp.ok) return resp.json();
    })
    .catch((error) => console.error(error));
};

export const deleteTemplateSubmission = async (submissionId: string, companyId: string): Promise<any> => {
  const user = auth.currentUser;
  if (!user) return;
  const token = await user.getIdToken();

  return await fetch(
    `${TENANT_API_BASE}/deleteFlexFormTemplateSubmission/${submissionId}?` +
      new URLSearchParams({ companyId }),
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": X_API_KEY,
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((resp) => {
      if (resp.ok) return { code: 200 };
    })
    .catch((error) => console.error(error));
};
